<template>
  <v-layout :column="isMobile">
    <cancel-load-dialog  v-model="showCancelModal"
     @refresh="removeLoad"
     :listing-human-id="_.get(selectedLoad, 'tacticalInfo.loadDetails.loadGroupHumanId', null)"
     :booked-load-id="_.get(selectedLoad, 'id', null)"
     :load-id="_.get(selectedLoad, 'humanId', null)">
    </cancel-load-dialog>

    <v-master-detail-pane @reset="$confirm('reset the dispatch overview')">
      <v-layout column slot="master" class="pl-2">
        <v-tabs v-model="selectedTab">
          <v-tab >
            Map Loads
          </v-tab>
          <v-tab >
            Drivers
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="selectedTab">
          <v-tab-item >
            <v-select-driver :company="company"
                             :value="selectedDriverId"
                             @change="driverFilterChange($event)">
            </v-select-driver>

            <v-card v-if="selectedLoad">
              <v-toolbar dense dark
                         :color="sidebarColor">
                <v-toolbar-title color>
                  {{selectedLoad.humanId}}
                </v-toolbar-title>
                <v-spacer />
                <v-btn v-if="selectedBookedLoad"
                       fab flat
                       @click="cancelBookedLoad()"
                       small color="white">
                  <v-icon >cancel</v-icon>
                </v-btn>
              </v-toolbar>

              <template v-if="isLoadGroup">
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="loadModel.customerName(selectedLoad)">
                        {{loadModel.customerName(selectedLoad)}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="loadModel.assignedTruckingCompanyDriverName(selectedLoad)">
                        {{loadModel.assignedTruckingCompanyDriverName(selectedLoad)}}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        {{ selectedLoad.loadGroup.availableLoadCount | pluralize('load', { includeNumber: true }) }} available
                      </v-list-tile-sub-title >
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <span class="font-italic">Pickup: </span>
                        {{ selectedLoad.pickupTime | formatDate }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider/>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        View Load
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn fab small
                             @click="viewLoad()"
                             color="accent">
                        <v-icon>chrome_reader_mode</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-list-tile>
                    <!--     if load group, user can direct dispatch user from here -->
                    <v-select-driver :company="company"
                                     :value="directDispatchDriverId"
                                     label="Direct Assignment"
                                     :loading="loadingBtn"
                                     @change="directDispatch($event)">
                    </v-select-driver>
                  </v-list-tile>
                </v-list>
                <v-list three-line v-if="selectedLoad.bookedLoads.length">
                  <v-subheader>
                    Assignments
                  </v-subheader>
                  <v-booked-load-planner-list-tile
                    v-for="bookedLoad in selectedLoad.bookedLoads"
                    :key="`booked_${bookedLoad.humanId}`"
                    :is-load-owner="false"
                    :company="company"
                    :load="bookedLoad"
                    @viewLoad="selectBookedLoad(bookedLoad)">
                  </v-booked-load-planner-list-tile>
                </v-list>
              </template>
              <v-list v-else two-line>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title v-if="loadModel.customerName(selectedLoad)">
                      {{loadModel.customerName(selectedLoad)}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title v-if="!isLoadGroup">
                      <template v-if="loadModel.loadNickname(selectedLoad)">
                        {{loadModel.loadNickname(selectedLoad)}}
                      </template>
                      <template v-else>
                        <b>From: </b> {{loadPickupRegion(selectedLoad)}} <br/>
                        <b>To: </b> {{loadDropoffRegion(selectedLoad)}}
                      </template>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title
                      v-if="loadModel.assignedTruckingCompanyDriverName(selectedLoad)">
                      {{loadModel.assignedTruckingCompanyDriverName(selectedLoad)}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title >
                      {{ hoursBetweenTimestamps(selectedLoad.pickupTime, selectedLoad.projectedDeliveryTime) | pluralize('hour', { includeNumber: true }) }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      <span class="font-italic">Pickup: </span>
                      {{ selectedLoad.pickupTime | formatDate }}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      <span class="font-italic">Delivery: </span>
                      {{ selectedLoad.projectedDeliveryTime | formatDate }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-divider/>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      View Load
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn fab small
                           @click="viewLoad()"
                           color="accent">
                      <v-icon>{{viewLoadIcon}}</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile>
                  <v-select-load-driver @refresh="onDriverChange($event)"
                                        :load="selectedLoad"
                                        label="Direct Assignment"
                                        :company="company">
                  </v-select-load-driver>
                </v-list-tile>
              </v-list>
            </v-card>

            <template v-if="selectedDriverId">
              <v-list v-if="_.first(spaceTimeBookedLoads)">
                <v-divider/>
                <v-subheader>{{ selectedDriverName }}</v-subheader>

                <template v-for="(load, idx) in spaceTimeBookedLoads">
                  <v-list-tile :key="`driver_assigned_load_${idx}_${load.humanId}`"
                               :class="[{'primary lighten-1': isSelectedLoad(load)},
                                  loadStyleClass(load)
                               ]"
                               :inactive="isSelectedLoad(load)"
                               @click="selectLoad(load)"
                               ripple avatar>

                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{  loadNickname(load) || _.get(load, 'sponsor.name', '...') }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title>
                        <span class="font-italic">Pickup:</span> {{ load.pickupTime | formatDate }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title>
                        <span class="font-italic">Delivery:</span>
                        {{ load.projectedDeliveryTime | formatDate }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-avatar :color="spaceTimeBookedLoadGradient(load)">
                      <span style="color: white;">{{ load.mapId }}</span>
                    </v-list-tile-avatar>

                  </v-list-tile>
                  <v-divider :key="`unassigned_divider_${idx}_${load.humanId}`"/>
                </template>
              </v-list>
              <v-list v-else>
                <v-divider/>
                <v-subheader>No Assignments.</v-subheader>
              </v-list>
            </template>

          </v-tab-item>
          <v-tab-item >
            <v-toolbar extended class="pb-2">
              <v-toolbar-title>
                Direct Dispatching
              </v-toolbar-title>

              <v-layout slot="extension" column>
                <div class="pa-0 ma-0 text-right align-center" v-if="accurateSince">
                  <v-layout row>
                    <v-chip label light
                            class="font-weight-light">
                      {{ accurateSince }}
                      <v-btn fab small flat
                             color="accent"
                             @click="loadDriverLoads">
                        <v-icon>refresh</v-icon>
                      </v-btn>
                    </v-chip>
                  </v-layout>
                </div>
              </v-layout>
            </v-toolbar>

            <v-card pl-4
                    class="pt-4"
                    :class="{'side-list-desktop': !isMobile}"
                    style="overflow: auto; max-height: 500px"
                    min-height="50vh">
              <v-layout v-if="loadingDirectDispatchAssignments" >
                <v-progress-circular indeterminate
                                     color="primary"
                                     class="mx-auto">
                </v-progress-circular>
              </v-layout>
              <v-list v-else two-line expand>
                <v-list-group-subheader-activator open
                                                  :subheader-text="`Awaiting Dispatch (${driversAwaitingDispatch.length})`"
                                                  toggle-open-icon="visibility"
                                                  toggle-close-icon="visibility_off">
                  <v-list-tile v-if="driversAwaitingDispatch.length === 0">
                    <v-list-tile-avatar>
                      <v-icon>sentiment_very_satisfied</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Great Work!</v-list-tile-title>
                      <v-list-tile-sub-title class="font-italic">nobody is waiting ...</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-for="driver in driversAwaitingDispatch">
                    <v-list-tile :key="`awaiting_dispatch_${driver.userId}`">
                      <v-list-tile-avatar>
                        <v-icon color="yellow">warning</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{driver.name}}</v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar :size="25">
                        <bqa-certificate-icon responsive
                                              :driver="driver">
                        </bqa-certificate-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </template>
                </v-list-group-subheader-activator>

                <v-list-group-subheader-activator open
                                                  subheader-text="Assignments"
                                                  toggle-open-icon="visibility"
                                                  toggle-close-icon="visibility_off">
                  <v-list-tile v-if="currentDriverAssignments.length === 0">
                    <v-list-tile-avatar>
                      <v-icon>sentiment_dissatisfied</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>No current assignments</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-for="assignment in currentDriverAssignments">
                    <v-list-tile v-if="assignment.tacticalInfo"
                                 :class="loadStyleClass(assignment)"
                                 :key="`dispatch_assignment_driver_${assignment.tacticalInfo.assignedTruckingCompanyDriverUserId}`">
                      <v-list-tile-avatar>
                        <v-icon>{{bookedLoadProgressIcon(assignment).icon}}</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{assignment.tacticalInfo.assignedTruckingCompanyDriverName}}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{loadPickupTime(assignment)}}, {{ loadNickname(assignment) || assignment.humanId}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title>
                          {{loadPickupRegion(assignment)}}
                          to {{loadDropoffRegion(assignment)}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar :size="25">
                        <bqa-certificate-icon responsive
                                              :driver="bookedLoadDriverInfo(assignment)">
                        </bqa-certificate-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </template>
                </v-list-group-subheader-activator>

                <v-list-group-subheader-activator open
                                                  subheader-text="Next Loads"
                                                  toggle-open-icon="visibility"
                                                  toggle-close-icon="visibility_off">
                  <template v-for="(assignment, idx) in nextDriverAssignments">
                    <template v-if="assignment.loads.length === 1">
                      <v-list-tile :key="`dispatch_next_assignment_driver_${idx}`"
                                   :class="loadStyleClass(assignment.loads[0])">
                        <v-list-tile-avatar>
                          <v-icon>{{bookedLoadProgressIcon(assignment.loads[0]).icon}}</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{assignment.name}}</v-list-tile-title>
                          <v-list-tile-sub-title>{
                            {loadPickupTime(assignment.loads[0])}}, {{ loadNickname(assignment.loads[0]) || assignment.loads[0].humanId}}
                          </v-list-tile-sub-title>
                          <v-list-tile-sub-title>
                            {{loadPickupRegion(assignment.loads[0])}}
                            to {{loadDropoffRegion(assignment.loads[0])}}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-avatar :size="25">
                          <bqa-certificate-icon responsive
                                                :driver="bookedLoadDriverInfo(assignment.loads[0])">
                          </bqa-certificate-icon>
                        </v-list-tile-avatar>
                      </v-list-tile>
                    </template>
                    <template v-if="assignment.loads.length > 1">
                      <v-list-group :key="`dispatch_next_assignment_driver_group_${idx}`">
                        <v-list-tile slot="activator">
                          <v-list-tile-avatar :size="20">
                            <v-chip small color="primary">
                              <span class="font-weight-bold white--text">
                                {{assignment.loads.length}}
                              </span>
                            </v-chip>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              <v-list-tile-title>{{assignment.name}}</v-list-tile-title>
                              <v-list-tile-sub-title>
                                {{assignment.loads.length}} loads
                              </v-list-tile-sub-title>
                            </v-list-tile-title>
                          </v-list-tile-content>
                          <v-list-tile-avatar :size="25">
                            <bqa-certificate-icon responsive
                                                  :driver="bookedLoadDriverInfo(assignment.loads[0])">
                            </bqa-certificate-icon>
                          </v-list-tile-avatar>
                        </v-list-tile>
                        <v-list-tile :key="`dispatch_next_assignment_driver_group_${idx}_${lidx}`"
                                     class="pl-1"
                                     v-for="(load, lidx) in assignment.loads"
                                     :class="loadStyleClass(load)">
                          <v-list-tile-avatar>
                            <v-icon>{{bookedLoadProgressIcon(load).icon}}</v-icon>
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title>{{loadDescription(load)}}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{loadPickupTime(load)}}, {{ loadNickname(load) || load.humanId}}
                            </v-list-tile-sub-title>
                            <v-list-tile-sub-title>
                              {{loadPickupRegion(load)}}
                              to {{loadDropoffRegion(load)}}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list-group>
                    </template>
                  </template>
                </v-list-group-subheader-activator>

                <v-list-group-subheader-activator open
                                                  :subheader-text="`Unavailable (${driversUnavailable.length})`"
                                                  toggle-open-icon="visibility"
                                                  toggle-close-icon="visibility_off">
                  <v-list-tile v-if="driversUnavailable.length == 0">
                    <v-list-tile-avatar>
                      <v-icon>sentiment_satisfied_alt</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Everybody is Available!</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-for="driver in driversUnavailable">
                    <v-list-tile :key="`dispatch_unavailable_${driver.userId}`">
                      <v-list-tile-title>{{driver.userName}}</v-list-tile-title>
                      <v-list-tile-avatar :size="25">
                        <bqa-certificate-icon responsive
                                              :driver="driver">
                        </bqa-certificate-icon>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </template>
                </v-list-group-subheader-activator>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-layout>

      <template slot="detail">
        <v-space-time-continuum @selectBookedLoad="selectBookedLoad($event)"
                                @selectPlannedLoad="selectPlannedLoad($event)"
                                @colorUpdate="updateSidebarColor($event)"
                                :stc-booked-loads="spaceTimeBookedLoads"
                                :stc-planned-loads="spaceTimePlannedLoads">
        </v-space-time-continuum>
      </template>
    </v-master-detail-pane>
  </v-layout>

</template>

<script>
import _ from 'lodash';
import API from '@/api';
import moment from 'moment';
import VLoadNavList from '@/components/dashboard/simple/LoadNavList';
import VListGroupSubheaderActivator from '@/components/lists/ListGroupSubheaderActivator';
import VMasterDetailPane from '@/components/MasterDetailPane';

import DirectDispatchingMixin from '@/mixins/directDispatchingMixin';
import BqaCertificateIcon from '@/components/BqaCertificateIcon';

import VSpaceTimeContinuum from '@/components/InfoWidgets/SpaceTimeContinuum';
import spaceTimeContinuumMixin from '@/mixins/spaceTimeContinuumMixin';
import VSelectDriver from '@/components/SelectDriver';
import VSelectLoadDriver from '@/components/SelectLoadDriver';

import { loadStatus } from '@/types';
import { hoursBetweenTimestamps } from '@/types/timestamp';
import loadModel from '@/types/models/load';
import CancelLoadDialog from '@/components/modals/CancelLoadDialog';
import VBookedLoadPlannerListTile from './BookedLoadPlannerListTile';

export default {
  name: 'VDirectDispatchOverview',
  mixins: [
    DirectDispatchingMixin,
    spaceTimeContinuumMixin,
  ],
  filters: {
    formatNextLoad(momentDate) {
      return momentDate.format('ddd MMM DD, H:mm A ');
    },
  },
  components: {
    VBookedLoadPlannerListTile,
    CancelLoadDialog,
    VSelectDriver,
    VSelectLoadDriver,
    VSpaceTimeContinuum,
    BqaCertificateIcon,
    VLoadNavList,
    VMasterDetailPane,
    VListGroupSubheaderActivator,
  },
  data: () => ({
    loadingBtn: false,
    selectedTab: null,
    selectedDriverId: null,
    reassignDriverId: null,
    selectedBookedLoad: null,
    selectedPlannedLoad: null,
    sidebarColor: null,
    directDispatchDriverId: null,
    showCancelModal: false,
  }),
  watch: {
    selectedDriverId() {
      this.resetSelected();
      this.reassignDriverId = this.selectedDriverId;
    },
    company() {
      this.selectedBookedLoad = null;
      this.selectedPlannedLoad = null;
      this.directDispatchDriverId = null;
    },
  },
  computed: {
    _() {
      return _;
    },
    loadModel() {
      return loadModel;
    },
    selectedLoad() {
      return this.selectedBookedLoad ? this.selectedBookedLoad : this.selectedPlannedLoad;
    },
    accurateSince() {
      if (this.loadingDirectDispatchAssignments) {
        return 'Loading ...';
      }

      return `Updated ${this.$options.filters.formatTimeStamp(this.directDispatchTime)}`;
    },
    driverAssignmentsByName() {
      return _.chain(this.directDispatchLoadAssignments)
        .groupBy('tacticalInfo.assignedTruckingCompanyDriverName')
        .value();
    },
    currentDriverAssignments() {
      const now = _.chain(this.driverAssignmentsByName)
        .map((v, k, m) => (v.length ? v[0] : null))
        .flatMap()
        .filter(l => l) // non-null
        .value();
      return now;
    },
    nextDriverAssignments() {
      const next = _.chain(this.driverAssignmentsByName)
        .map((v, k, m) => ({ name: k, loads: _.slice(v, 1) }))
        .filter(v => v.loads.length > 0)
        .value();
      return next;
    },
    viewLoadIcon() {
      let icon;
      switch (_.get(this, 'selectedLoad.loadStatus', '')) {
        case loadStatus.SCHEDULED:
          icon = 'schedule';
          break;
        case loadStatus.IN_TRANSIT:
          icon = 'local_shipping';
          break;
        default:
          icon = 'done';
      }

      return icon;
    },
    driversAwaitingDispatch() {
      return this.directDispatchDriversAwaitingAssignment;
    },
    driversUnavailable() {
      return this.directDispatchDriversUnavailable;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    selectedDriverName() {
      const first = _.first(this.spaceTimeBookedLoads);

      if (first) {
        // return Loads.assignedTruckingCompanyDriverName(_.first(this.spaceTimeBookedLoads));
        return this.bookedLoadAssignedTruckingCompanyDriverName(first);
      }

      return null;
    },

    // enter space-time
    upcomingBookedLoads() {
      return _.chain(this.bookedLoads)
        .filter(l => !l.pickupTime || this.isBookedLoadPickedUpAfter(l, moment()))
        .value();
    },
    normalizedBookedLoads() {
      return _.chain(this.upcomingBookedLoads)
        .cloneDeep()
        .map(l => this.normalizeBookedLoad(l))
        .sortBy('pickupTime', 'asc')
        .value();
    },
    normalizedPlannedLoads() {
      return _.chain(this.planningLoadGroupUnassignedLoads)
        .cloneDeep()
        .map(l => this.normalizePlannedLoad(l))
        .sortBy('pickupTime', 'asc')
        .value();
    },
    spaceTimeBookedLoads() {
      return _.chain(this.normalizedBookedLoads)
        .filter(l => l.loadStatus === loadStatus.SCHEDULED || l.loadStatus === loadStatus.IN_TRANSIT)
        .filter(l => this.selectedDriverId && this.selectedDriverId === l.tacticalInfo.assignedTruckingCompanyDriverUserId)
        .map((bookedLoad, idx) => {
          bookedLoad.mapId = String.fromCharCode(97 + idx).toUpperCase();
          return bookedLoad;
        })
        .value();
    },
    spaceTimePlannedLoads() {
      const plannedLoadsInBookedLoadList = this.spaceTimeBookedLoads
        .map(booked => booked.tacticalInfo.loadDetails.loadGroupHumanId);
      const filtereddPlannedLoads = this.normalizedPlannedLoads
        .filter(plannedLoad => plannedLoadsInBookedLoadList.indexOf(plannedLoad.humanId) === -1);

      return filtereddPlannedLoads.map((load, idx) => {
        load.mapId = idx + 1;
        return load;
      });
    },
    isLoadGroup() {
      return _.get(this.selectedLoad, 'loadGroup', false);
    },
  },
  methods: {
    removeLoad(humanId) {
      this.showCancelModal = false;
      this.$store.dispatch('bookedLoads/removeLoad', humanId);
      this.selectedBookedLoad = null;
    },
    viewBookedLoadDetail(bookedLoadId) {
      this.$router.push({ name: 'load.detail', params: { loadId: bookedLoadId } });
    },
    onDriverChange(bookedLoad) {
      this.replaceBookedLoad(bookedLoad);
      this.resetSelected();
    },
    cancelBookedLoad() {
      this.showCancelModal = true;
    },
    driverFilterChange(event) {
      this.selectedDriverId = event;
    },
    viewLoad() {
      if (this.isLoadGroup) {
        this.$router.push({
          name: 'company.loads.planner.section',
          params: {
            id: this.company.id,
            loadGroupId: this.selectedLoad.humanId,
          },
        });
      } else {
        this.$router.push({
          name: `company.loads.${this.selectedLoad.loadStatus.toLowerCase()}.section`,
          params: {
            id: this.company.id,
            bookedLoadId: this.selectedLoad.humanId,
          },
        });
      }
    },
    async directDispatch(driverId) {
      try {
        this.loadingBtn = true;
        const apiResponse = await API.planner.assignTrucks({
          loadId: this.selectedLoad.humanId,
          body: {
            companyId: this.selectedLoad.loadGroup.details.listingCompany.id,
            truckCount: 1,
            driverUserId: driverId,
          },
        });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Assigned',
          timeout: 4000,
        });

        this.selectedPlannedLoad = apiResponse.data;
        this.loadBookedLoads(this.company.id);
        this.$set(this, 'directDispatchDriverId', null);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    selectLoad(load) {
      // TODO: check if it's booked or planned load?
      this.selectBookedLoad(load);
    },
    hoursBetweenTimestamps(from, to) {
      return hoursBetweenTimestamps(from, to);
    },
    updateSidebarColor(color) {
      this.sidebarColor = color;
    },
    loadStyleClass(load) {
      return this.bookedLoadStyleClass(this.company, load);
    },
    loadDescription(load) {
      const ownerName = _.get(load, 'tacticalInfo.loadDetails.listingCompany.name');
      const customerName = _.get(load, 'tacticalInfo.loadDetails.customerCompany.name', ownerName);
      return this.loadNickname(load) || customerName;
    },
    loadNickname(load) {
      const v1 = _.get(load, 'tacticalInfo.loadDetails.nickname');
      return _.get(load, 'tacticalInfo.loadGroup.details.nickname', v1);
    },
    loadPickupTime(load) {
      const when = moment(load.pickupTime);
      return this.$options.filters.formatNextLoad(when);
    },
    loadPickupRegion(load) {
      return load.tacticalInfo.loadDetails.pickupLocation.googlePlace.region;
    },
    loadDropoffRegion(load) {
      return load.tacticalInfo.loadDetails.dropoffLocation.googlePlace.region;
    },
    moment() {
      return moment;
    },
    loadDriverLoads() {
      this.loadDirectDispatchAssignments();
    },

    // enter space-time
    selectBookedLoad(bookedLoad) {
      this.selectedBookedLoad = bookedLoad;
      this.selectedPlannedLoad = null;
    },
    selectPlannedLoad(plannedLoad) {
      this.selectedBookedLoad = null;
      this.selectedPlannedLoad = plannedLoad;
    },
    isSelectedLoad(load) {
      return load.humanId === _.get(this.selectedBookedLoad, 'humanId', null);
    },
    normalizeBookedLoad(load) {
      // eslint-disable-next-line no-param-reassign
      load.sponsor = load.tacticalInfo.loadDetails.customerCompany || load.tacticalInfo.loadDetails.listingCompany;
      // eslint-disable-next-line no-param-reassign
      load.pickupTime = load.tacticalInfo.estimatedPickup || load.tacticalInfo.scheduledPickupTime;
      // eslint-disable-next-line no-param-reassign
      load.projectedDeliveryTime = this.bookedLoadProjectedDeliveryMoment(load);

      return load;
    },
    normalizePlannedLoad(load) {
      // eslint-disable-next-line no-param-reassign
      load.sponsor = this.loadGroupSponsor(load);
      // eslint-disable-next-line no-param-reassign
      load.pickupTime = this.loadGroupScheduledPickupTime(load);
      // eslint-disable-next-line no-param-reassign
      load.projectedDeliveryTime = this.plannedLoadProjectedDeliveryMoment(load);

      return load;
    },
    resetSelected() {
      this.selectedBookedLoad = null;
      this.selectedPlannedLoad = null;
    },
  },
};
</script>

<style scoped>
  .driver_accepted {
    border-left: 5px green solid;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Loads/components/DirectDispatchOverview.vue